import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
import Switch from "@mui/material/Switch";
import React from "react";
import Grid from "@mui/material/Grid2";
import { ui } from "../../../../../../../../../interfaces/interfaces";
import { useAppSelector } from "@store/hooks";

type Props = {}

const PlanSwitch: React.FC<Props> = () => {
  const serviceAgreementOffered = useAppSelector(({ ui }) => ui.CarePlanOffered)

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
    ui["CarePlanOffered"] = checked
  };

  return (
    (<Grid
      size={{
        xs: 12,
        sm: 6
      }}>
      <FormGroup row style={{ margin: 0, padding: 0 }}>
        <FormControlLabel
          control={<Switch checked={serviceAgreementOffered} onChange={handleChange} name={`ServiceAgreementOffered`} color="primary" />}
          label="Care Plan Offered?"
          style={{ marginBottom: 0 }}
        />
      </FormGroup>
    </Grid>)
  );
}

export default PlanSwitch